import type React from 'react';

import { useTranslation } from 'react-i18next';

import { colorsPalettes } from '@similarweb/styles';

import { LeadPriorityScore } from '../../../../domain/signal';

import { StyledBarContainer, StyledBarItem, StyledLeadPriorityChip } from './styles';

const TYPE_CONFIG = {
  [LeadPriorityScore.High]: {
    labelKey: 'company.signals.lead_priority.chip.high',
    colors: [colorsPalettes.torquoise[400], colorsPalettes.torquoise[400], colorsPalettes.torquoise[400]],
    heights: [5, 9, 13],
    textColor: colorsPalettes.carbon[400],
  },
  [LeadPriorityScore.Medium]: {
    labelKey: 'company.signals.lead_priority.chip.medium-short',
    colors: [colorsPalettes.yellow[400], colorsPalettes.yellow[400], colorsPalettes.carbon[50]],
    heights: [5, 9, 13],
    textColor: colorsPalettes.carbon[400],
  },
  [LeadPriorityScore.Low]: {
    labelKey: 'company.signals.lead_priority.chip.low',
    colors: [colorsPalettes.sky[500], colorsPalettes.carbon[50], colorsPalettes.carbon[50]],
    heights: [5, 9, 13],
    textColor: colorsPalettes.carbon[400],
  },
  [LeadPriorityScore.Unlock]: {
    labelKey: 'company.signals.lead_priority.chip.unlock-score',
    colors: [],
    heights: [],
    textColor: colorsPalettes.carbon[400],
  },
  [LeadPriorityScore.NoScore]: {
    labelKey: 'company.signals.lead_priority.chip.no-score',
    colors: [],
    heights: [],
    textColor: colorsPalettes.carbon[400],
  },
};

type Props = {
  score: LeadPriorityScore;
};

export const LeadPriorityChip: React.FC<Props> = ({ score }) => {
  const { t } = useTranslation();

  const config = TYPE_CONFIG[score] ?? TYPE_CONFIG[LeadPriorityScore.Unlock];

  return (
    <StyledLeadPriorityChip textColor={config.textColor}>
      {score !== LeadPriorityScore.Unlock && score !== LeadPriorityScore.NoScore ? (
        <StyledBarContainer>
          {Array.from({ length: 3 }).map((_, index) => (
            <StyledBarItem height={config.heights[index]} color={config.colors[index]} key={index} />
          ))}
        </StyledBarContainer>
      ) : null}

      {t(config.labelKey)}
    </StyledLeadPriorityChip>
  );
};
